
<v-hover v-slot="{ hover }" open-delay="200" ref="hover">
    <div class="app-side-buttons menu-top-space" >
        <v-scale-transition>
            <div v-show="hover || permanent || showMenu" v-if="incident">
                <inc-create-button
                    v-if       = "incident"
                    :site      = "incident.sites[0].id"
                    @opend     = "onSubmenuOpen"
                    class      = "mb-3"
                />

                <c-menu-button
                    label      = "inc.edit.menu.save"
                    icon       = "mdi-content-save-outline"
                    icon-color = "primary--text"
                    @click     = "onSave"
                />

                <c-menu-button
                    label      = "inc.edit.menu.email"
                    icon       = "mdi-email-outline"
                    icon-color = "primary--text"
                    @click     = "onMail"
                />

                <c-menu-button
                    v-if       = "!incident.refresh"
                    label      = "inc.edit.menu.reload"
                    icon       = "mdi-reload"
                    icon-color = "primary--text"
                    @click     = "onRefresh"
                />

                <c-menu-button
                    label      = "inc.edit.menu.history"
                    icon       = "mdi-history"
                    icon-color = "primary--text"
                    @click     = "onHistory"
                />

                <c-menu-button
                    v-if       = "isClipboardAllowed && !clipboardEntry"
                    label      = "clipboard.add.tooltip"
                    icon       = "mdi-clipboard-plus-outline"
                    icon-color = "primary--text"
                    @click     = "onClipboard"
                />

                <c-menu-button
                    v-if       = "isClipboardRemoveAllowed && clipboardEntry"
                    label      = "clipboard.remove.tooltip"
                    icon       = "mdi-clipboard-remove-outline"
                    icon-color = "error--text"
                    @click     = "onClipboarRemove"
                />

                <inc-print-button
                    v-if       = "incident"
                    @opend     = "onSubmenuOpen"
                    :incident  = "incident"
                    :index     = "index"
                    class      = "mb-3"
                />

                <inc-change-button
                    v-if       = "preferences['dataadmin'] &&  !incident.deleted && allowed.length > 0"
                    :incident  = incident
                    :allowed   = "allowed"
                    @opend     = "onSubmenuOpen"
                    @changed   = "onChanged"
                    class      = "mb-3"
                />

                <c-menu-button
                    v-if       = "preferences['dataadmin'] &&  !incident.deleted"
                    label      = "inc.delete.tooltip"
                    icon       = "mdi-delete-outline"
                    icon-color = "red--text"
                    @click     = "onDelete"
                />

                <c-menu-button
                    v-if       = "preferences['dataadmin'] &&  incident.deleted"
                    label      = "inc.undelete.tooltip"
                    icon       = "mdi-undo"
                    icon-color = "primary--text"
                    @click     = "onUnDelete"
                />
            </div>
        </v-scale-transition>
    </div>
</v-hover>
